import React from 'react';
import CheckoutPage from './CheckoutPage';
import { SwitchTestProviderSsr } from '../SwitchTestProviderSsr/SwitchTestProviderSSR';
import { CHECKOUT_SWITCHES_SSR } from '../../tools/constants';

export default function CheckoutWrapper() {
  return (
    <SwitchTestProviderSsr keysWithTypeAndDefaultValue={CHECKOUT_SWITCHES_SSR} switchName="FetchCheckoutPageSwitches">
      <CheckoutPage />
    </SwitchTestProviderSsr>
  );
}
